<template>
  <div class="scraper-settings-page min-w-0">
    <Head :title="__('Collector')" />
    <ScraperSettingsApp
      :settings-url="settingsUrl"
      :save-url="saveUrl"
      :disable-url="disableUrl"
      :enable-url="enableUrl"
      :restart-url="restartUrl"
      :can-edit="canEdit"
      :logs-url="logsUrl"
    />
  </div>
</template>

<script setup>
import ScraperSettingsApp from '../components/ScraperSettingsApp.vue'

defineProps({
  settingsUrl: {
    type: String,
    required: true,
  },
  saveUrl: {
    type: String,
    required: true,
  },
  disableUrl: {
    type: String,
    required: true,
  },
  enableUrl: {
    type: String,
    required: true,
  },
  restartUrl: {
    type: String,
    required: true,
  },
  canEdit: {
    type: Boolean,
    default: false,
  },
  logsUrl: {
    type: String,
    required: true,
  },
})
</script>
